import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserInfoService } from '@softline/auth';
import { interval } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

// TODO: move the hard-coded German greeting strings to i18n keys in src/i18n
@Component({
  selector: 'soft-dashboard-greeting',
  imports: [DatePipe],
  templateUrl: './dashboard-greeting.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardGreetingComponent {
  private readonly userInfo = inject(UserInfoService);

  readonly today = toSignal(
    interval(1_000).pipe(
      startWith(0),
      map(() => new Date())
    ),
    { requireSync: true }
  );

  readonly greeting = computed(() => {
    const hour = this.today().getHours();
    const name = this.userInfo.value()?.userFullName ?? '';

    if (hour < 11) return `Guten Morgen, ${name}!`;
    if (hour < 14) return `Mahlzeit, ${name}!`;
    if (hour < 18) return `Hallo, ${name}!`;
    return `Guten Abend, ${name}!`;
  });

  readonly greetingIcon = computed(() => {
    const hour = this.today().getHours();
    if (hour < 11) return '☀️';
    if (hour < 14) return '🍽️';
    if (hour < 18) return '⛅';
    return '🌙';
  });
}
